module.exports = __webpack_public_path__ + "img/crm.af4f65f.svg";